module.exports = __webpack_public_path__ + "img/Products_Desktop_03.9d508b71.jpg";